import { defineStore } from "pinia";

export const useWishlistStore = defineStore("wishlist", {
	state: () => {
		return {
			wishlistCount: 0,
			wishlistItems: {},
		};
	},
	actions: {
		setWishlistItems(items) {
			this.wishlistItems = items;
			this.wishlistCount = Object.keys(items).length;
		},
	},
});
